import { HorizontalCardGroup } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { TXTWCL_Popular_Bet_Builders } from './PopularBetBuilders.messages.json';
import styles from './PopularBetBuilders.scss';
import PopularBetBuilderCard from './components/PopularBetBuilderCard/PopularBetBuilderCard';
import type { PopularBetBuilder } from './types';
import bgImage from './widget-bg.png';

interface Props {
  popularBetBuilders: PopularBetBuilder[];
  isEventPage?: true;
}

export const PopularBetBuilders: React.FC<Props> = ({ popularBetBuilders, isEventPage }) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <SportsComponent name="Sports Popular Bet Builders Component">
      <div className={styles.panel}>
        <header className={styles.panelHeader}>
          <Icon size="xl" name="bet-builder" label={formatMessage(TXTWCL_Popular_Bet_Builders)} />
          <span>
            <Translation {...TXTWCL_Popular_Bet_Builders} />
          </span>
        </header>
        <HorizontalCardGroup
          className={styles.horizontalCardGroup}
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          {popularBetBuilders.map((popularBetBuilder) => (
            <PopularBetBuilderCard
              key={popularBetBuilder.runnersIds.map(({ selectionId }) => selectionId).join('-')}
              popularBetBuilder={popularBetBuilder}
              isEventPage={isEventPage}
            />
          ))}
        </HorizontalCardGroup>
      </div>
    </SportsComponent>
  );
};
